<app-maintenance></app-maintenance>

@if (!showMaintenance) {
  <div
    [class.loading]="isLoading()"
    class="powerx-main powerx-page scroll-style"
    >
    <app-strategy-skeleton [isVisible]="isLoading() && !showMaintenance"></app-strategy-skeleton>
    <div
      #subMenu
      class="main-menu"
      >
      <div class="mobile-header">
        <mat-icon
          [svgIcon]="'power-x-icon'"
          class="sub-menu-strategy-icon"
        ></mat-icon>
        <p class="menu-title">
          {{ strategiesNames.PowerX }}
        </p>
      </div>
      <div class="search-bar-section">
        <div class="header-container desktop-header">
          <p class="header with-divider">
            {{ strategiesNames.PowerX }}
          </p>
        </div>
        <div class="search-bar">
          <app-search-bar [isPowerX]="true"></app-search-bar>
          <!--     use as a slot into symbol-search     -->
          <!-- <app-ai-chat-analyze-button
          [trigger]="analyzeTriggerDetails()"
          *appHideForUnavailableFeature="features.PxoAiChat"
          hint="Analyze this symbol"
        ></app-ai-chat-analyze-button> -->
      </div>
    </div>
    <div class="long-position">
      <button
        [ngClass]="tradePosition === TradePositions.LongAndShort ? 'grey' : ''"
        [matMenuTriggerFor]="menu"
        [class]="tradePosition"
        mat-button
        class="long-position-button"
        >
        <!--  TODO: do not use functions in templates  -->
        {{ getTradePositionName(tradePosition) }}
      </button>
      <mat-menu
        #menu="matMenu"
        class="position-dropdown"
        >
        @for (tPosition of [TradePositions.LongOnly, TradePositions.ShortOnly, TradePositions.LongAndShort]; track tPosition) {
          <button
            [ngStyle]="{ 'background-color': tradePosition === tPosition ? 'var(--selected-item-bg)' : '' }"
            (click)="updatePosition(tPosition)"
            mat-menu-item
            >
            <!--  TODO: do not use functions in templates  -->
            {{ getTradePositionName(tPosition) }}
          </button>
        }
      </mat-menu>
    </div>
    <div class="account-size-container">
      <div
        (click)="positionSizing()"
        class="account-size"
        >
        @let formattedValues = accountSizeFormattedValues();
        <div class="size">
          <span>Account</span>
          <p>${{ formattedValues.accountSizeFormatted }}</p>
        </div>
        <div class="risk">
          <span>Risk</span>
          <div class="risk-inner-div">
            <p>{{ formattedValues.accountRiskPercentFormatted }}%</p>
            <p>${{ formattedValues.riskAmountPerTradeFormatted }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="run-scanner-container">
      @if (!showMaintenance) {
        <app-run-scanner-button></app-run-scanner-button>
      }
    </div>
    <div class="print-data-container">
      @if (!isMobileOS && !showMaintenance) {
        <div class="print-data-group">
          <button
            (click)="openPrintModal()"
            mat-icon-button
            class="open-print-button"
            >
            <mat-icon
              [svgIcon]="'print'"
              class="print-icon"
            ></mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
  <div class="power-x-content">
    <div
      [ngStyle]="{ '--custom-width-with-pinned-order-panel': showOrderPanel ? '370px' : '0px' }"
      [ngClass]="{ 'chart-tab': currentChartTab === ChartTabs.Chart }"
      class="left-side"
      >
      <app-symbol-menu
        [elementsTabVisibilityConfig]="powerxTabsVisibilityConfig"
        [tab]="currentChartTab"
        [isOpened]="isSymbolMenuOpened"
        [securityId]="symbolId$ | async"
        (tabChanged)="onChangeChartTab($event)"
        (toggleSymbolMenu)="onSymbolMenuToggle()"
        (changeSecurityId)="changeSecurityId($event)"
        >
        <ng-container data-window>
          <app-data-window
            [isPrint]="false"
            (openNews)="onChangeChartTab(chartTabs.News)"
          ></app-data-window>
        </ng-container>
        <ng-container trading-report>
          <app-trading-report [isPrint]="false"></app-trading-report>
        </ng-container>
        <ng-container options>
          <app-options [isPrint]="false"></app-options>
        </ng-container>
      </app-symbol-menu>
      @if (currentChartTab === ChartTabs.Chart) {
        <app-trading-chart
          class="chart"
        ></app-trading-chart>
      }
    </div>
    @if (showOrderPanel) {
      <app-trading-panel-order-panel></app-trading-panel-order-panel>
    }
    <div class="right-side">
      <as-split
        direction="horizontal"
        class="all-section"
        gutterSize="4"
        >
        <as-split-area>
          <as-split
            direction="vertical"
            gutterSize="4"
            >
            <as-split-area
              [size]="35"
              minSize="25"
              class="right-one"
              >
              <app-scanner-watchlist-panel></app-scanner-watchlist-panel>
            </as-split-area>
            <as-split-area
              [size]="65"
              minSize="25"
              class="right-two h-less-991"
              gutterSize="11"
              >
              <app-data-window
                [isPrint]="false"
                (openNews)="onChangeChartTab(chartTabs.News)"
              ></app-data-window>
            </as-split-area>
          </as-split>
        </as-split-area>
      </as-split>
    </div>
  </div>
</div>
}
